import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import { Routes, Route } from "react-router-dom";
import BackToTop from "./Common/BackToTop/BackToTop";
import Faq from "./Common/Faq/Faq";
import TopBar from "./Components/TopBar/TopBar";
import Service from "./Pages/Service/Service";
import Contact from "./Pages/Contact/Contact";
import Aboutus from "./Pages/Aboutus/Aboutus";
import Locations from "./Pages/Locations/Locations";
import Technology from "./Pages/Technology/Technology";
import Emergencies from "./Pages/Emergencies/Emergencies";
import Carrer from "./Pages/Carrer/Carrer";
import ServiceDetail from "./Pages/Service/ServiceDetail";
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import Itservices from "./Pages/ITservices/ITservices";
import Consulting from "./Common/Consulting";

const RandomFloatingBlob = ({ className, initialStyle }) => {
  const controls = useAnimation();

  const generateRandomPosition = () => ({
    x: Math.random() * 300 - 150,
    y: Math.random() * 300 - 150,
  });

  const startFloating = async () => {
    while (true) {
      await controls.start(generateRandomPosition(), {
        duration: 1 + Math.random() * 5,
        ease: "easeInOut",
      });
    }
  };

  useEffect(() => {
    startFloating();
  }, []);

  return (
    <motion.div className={className} style={initialStyle} animate={controls} />
  );
};

function App() {
  return (
    <>
      <TopBar />
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/Service" element={<Service />} />
        <Route path="/Career" element={<Carrer />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Aboutus" element={<Aboutus />} />
        <Route path="/Locations" element={<Locations />} />
        <Route path="/Technology" element={<Technology />} />
        <Route path="/Emergencies" element={<Emergencies />} />
        <Route path="/Service/:id" element={<ServiceDetail />} />
        <Route path="/itservices" element={<Itservices />} />
        <Route path="/consulting" element={<Consulting />} />
      </Routes>
      <BackToTop />
      <Footer />

      <div className="fixed top-0 left-0 w-full h-full -z-10 overflow-hidden pointer-events-none">
        <RandomFloatingBlob
          className="absolute w-72 h-72 bg-red-200 opacity-20 blur-3xl rounded-full"
          initialStyle={{ top: "10%", left: "5%" }}
        />
        <RandomFloatingBlob
          className="absolute w-96 h-96 bg-red-200 opacity-20 blur-3xl rounded-full"
          initialStyle={{ bottom: "15%", right: "10%" }}
        />
        <RandomFloatingBlob
          className="absolute w-80 h-80 bg-red-200 opacity-20 blur-3xl rounded-full"
          initialStyle={{ top: "50%", right: "40%" }}
        />
        <RandomFloatingBlob
          className="absolute w-64 h-64 bg-red-200 opacity-20 blur-3xl rounded-full"
          initialStyle={{ bottom: "5%", left: "20%" }}
        />
      </div>
    </>
  );
}

export default App;
